import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      d: "M8 12.875a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
      class: "fill-secondary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M8 2.875a1 1 0 0 1-1-1v-.5a1 1 0 0 1 2 0v.5a1 1 0 0 1-1 1M8 16.375a1 1 0 0 1-1-1v-.5a1 1 0 1 1 2 0v.5a1 1 0 0 1-1 1M1.5 9.375H1a1 1 0 0 1 0-2h.5a1 1 0 0 1 0 2M15 9.375h-.5a1 1 0 1 1 0-2h.5a1 1 0 1 1 0 2M3.405 4.78a1 1 0 0 1-.707-.295l-.355-.36A1 1 0 0 1 3.75 2.718l.353.355a1 1 0 0 1-.705 1.707zM12.95 14.325a1 1 0 0 1-.7-.292l-.353-.355a1.002 1.002 0 0 1 .3-1.67 1 1 0 0 1 1.112.257l.348.36a1 1 0 0 1-.708 1.7M12.596 4.78a1 1 0 0 1-.705-1.707l.36-.355a1 1 0 0 1 1.407 1.407l-.355.353a1 1 0 0 1-.707.302M3.05 14.325a1 1 0 0 1-.707-1.7l.355-.352a1 1 0 1 1 1.412 1.412l-.36.348a1 1 0 0 1-.7.292",
      class: "fill-primary"
    }, null, -1)
  ])))
}
export default { render: render }